import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import {
  useBankAccount,
  useIdentityValidation,
  useStoreInfo,
} from 'commons/hooks';
import {
  dataDogLogger,
  DataDogLoggerActionTypes,
} from 'commons/utils/dataDogLogger';
import { isPepOrSoRoute, useIdValidationRoutes } from '../hooks';
import IntroductoryInfoSkeleton from './IntroductoryInfoSkeleton';

function IntroductoryInfo(): JSX.Element {
  const { storeInfo } = useStoreInfo();
  const identityValidation = useIdentityValidation();
  const bankAccount = useBankAccount();
  const { getNextRoute } = useIdValidationRoutes();

  useEffect(() => {
    dataDogLogger.generate({
      actionMessage: `Store ${storeInfo.id} started new id validation flow`,
      actionOwner: 'IntroductoryInfo',
      actionType: DataDogLoggerActionTypes.Info,
      actionData: {
        storeId: storeInfo.id,
      },
    });
  }, [storeInfo.id]);

  if (identityValidation.isLoading || bankAccount.isLoading) {
    return <IntroductoryInfoSkeleton />;
  }

  const nextRoute = getNextRoute() ?? isPepOrSoRoute;
  return <Redirect to={nextRoute} />;
}

export default IntroductoryInfo;
